import { render, staticRenderFns } from "./FollowupFinished.vue?vue&type=template&id=601ac014&scoped=true&"
import script from "./FollowupFinished.vue?vue&type=script&lang=js&"
export * from "./FollowupFinished.vue?vue&type=script&lang=js&"
import style0 from "./FollowupFinished.vue?vue&type=style&index=0&id=601ac014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ac014",
  null
  
)

export default component.exports